import React from "react";
import KeyMetrics from "./KeyMetrics";
import StatusBreakdown from "./StatusBreakdown";
import CountryStats from "./CountryStats";
import MonthlyStats from "./MonthlyStats";
import { OrderStats, User } from "./types";

interface PostOfficeDashboardProps {
  stats: OrderStats | null;
  currentUser?: User;
  timePeriod: string;
}

const PostOfficeDashboard: React.FC<PostOfficeDashboardProps> = ({
  stats,
  currentUser,
  timePeriod,
}) => {
  return (
    <>
      {/* Key Metrics - Shipping-focused metrics for post office managers */}
      <KeyMetrics stats={stats} currentUser={currentUser} />

      {/* Status Breakdown and Country Stats */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
        <StatusBreakdown stats={stats} currentUser={currentUser} />
        <CountryStats stats={stats} currentUser={currentUser} />
      </div>

      {/* Period Statistics Chart */}
      <MonthlyStats
        stats={stats}
        currentUser={currentUser}
        timePeriod={timePeriod}
      />
    </>
  );
};

export default PostOfficeDashboard;
